require('./coffeekup.coffee');
require('./datetime.coffee');
require('./exprParser.js');
require('./context.coffee');
require('./coffeekup.coffee');
require('./variables.coffee');
require('./questions.coffee');
require('./flashcanvas-config.js');
window.simplify = require('simplify-js');
require('./jSignature.min.js');
require('./flashcanvas.js');
require('./survey.coffee');

let survey = require('./survey.js');
let page = require('./survey.coffee').Page;
let question = require('./questions.coffee').Question;
let logic = require('./logic.coffee');
let expr = require('./expression.coffee');
let utils = require('./utils.coffee');
let dateTools = require('./datetime.js');
let context = require('./context.coffee');
let variables = require('./variables.coffee');

window.EvaluationVisitor = logic.EvaluationVisitor;
window.SurveyLogic = survey.SurveyLogic;
window.onSurveyLoad = survey.onSurveyLoad;
window.ExprParser  = expr;
window.randomString = utils.randomString;
window.dateTools = dateTools;
window.Page = page;
window.Question = question;
window.trans = utils.trans;
window.Choice = utils.Choice;
window.QuestionContext = context.QuestionContext;
window.ThreeDMatrixContext = context.ThreeDMatrixContext;
window.StringVariable = variables.StringVariable;
window.VariableContext = context.VariableContext;
window.getVariableQuery = survey.getVariableQuery;



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.applicant/surveys/index.js